import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface Props {
  label: string;
  to?: string;
  onClick?: () => void;
}

export function BreadcrumbItem(props: Props): React.ReactElement {
  return (
    <Item>
      {props.to ? (
        <StyledLink to={props.to} onClick={props.onClick}>
          {props.label}
        </StyledLink>
      ) : (
        <StyledText onClick={props.onClick}>{props.label}</StyledText>
      )}
    </Item>
  );
}

const Item = styled.li``;

const StyledLink = styled(Link)`
  display: block;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.8125rem;
  line-height: 1.1875rem;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    color: #eb0000;
    text-decoration: underline;
  }
`;

const StyledText = styled.span`
  display: block;
  color: #b6b6b6;
  font-size: 0.8125rem;
  line-height: 1.1875rem;
`;
